import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

import * as c from "./dMSideBySidePageHeader.module.scss";
import { processMarkdown } from "@utils/markdown";
import { ContentfulCta } from "@components/shared/cta";
import EmailCaptureForm from "@components/shared/emailCapture/emailCaptureForm";
import { useSlideEnterAnimation } from "@hooks/useSlideEnterAnimation";

export const DMSideBySidePageHeader = ({ pageHeaderData = {} }) => {
  const {
    label,
    labelColor,
    darkBackground,
    heading,
    subheading,
    cta,
    ctaSecondary,
    ctaEmailCapture,
    desktopImage,
    mobileImage,
    backgroundColor,
    logoImage,
  } = pageHeaderData;

  const subheadingText = subheading?.subheading;
  const hasCtas = cta || ctaSecondary;

  useSlideEnterAnimation();

  return (
    <div
      className={classNames(c.sideBySide, darkBackground && c.dark)}
      style={{
        background: backgroundColor?.value ? backgroundColor?.value : "none",
        "--bg-color": backgroundColor?.value || "none",
        "--labelColor": labelColor?.value || (darkBackground ? "#b7bce6" : "#fcfafa"), // blue-300 : cream-100
      }}
    >
      <section className={c.sideBySidePageRow}>
        <div className={c.sideBySideHeader} data-transition="slide-enter-child">
          {logoImage ? (
            <GatsbyImage image={getImage(logoImage)} alt="" className={c.labelImage} />
          ) : (
            label && <h2 className={classNames(c.eyebrow, "eyebrow")}>{label}</h2>
          )}

          <h1 className={classNames(c.headline, "h1")} dangerouslySetInnerHTML={{ __html: heading }} />

          {subheadingText && (
            <div
              className={classNames(c.subheading, "p2")}
              dangerouslySetInnerHTML={{ __html: processMarkdown(subheadingText) }}
            />
          )}

          {hasCtas && (
            <div className={classNames(c.ctaContainer, ctaSecondary && c.ctaWrap)}>
              {cta && (
                <ContentfulCta
                  {...cta}
                  style={cta.style?.[0] !== "Button Secondary" ? "Button Primary" : "Button Secondary"}
                />
              )}
              {ctaSecondary && <ContentfulCta {...ctaSecondary} />}
            </div>
          )}

          {ctaEmailCapture && (
            <EmailCaptureForm className={c.emailCapture} formSource="bm_newsletter" {...ctaEmailCapture} />
          )}
        </div>

        <div className={c.imageContainer}>
          {desktopImage && (
            <GatsbyImage
              image={getImage(desktopImage)}
              loading="eager"
              alt={label ? `${label} - Desktop image` : "Desktop image"}
            />
          )}
          {mobileImage && (
            <GatsbyImage
              image={getImage(mobileImage)}
              loading="eager"
              alt={label ? `${label} - Mobile image` : "Mobile image"}
            />
          )}
        </div>
      </section>
    </div>
  );
};
